import { useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useDataValue({
    context: 'appointment_overlay',
    path: 'note',
    viewPath: props.viewPath,
  })
}
